import { render } from "./aio-login-dashboard-docs.vue?vue&type=template&id=1d3f2396&scoped=true"
import script from "./aio-login-dashboard-docs.vue?vue&type=script&lang=js"
export * from "./aio-login-dashboard-docs.vue?vue&type=script&lang=js"

import "./aio-login-dashboard-docs.vue?vue&type=style&index=0&id=1d3f2396&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3f2396"]])

export default __exports__